// ACTION TYPE FETCH_ARTICLES
export const FETCH_STATIONS = 'FETCH_STATIONS';

// ACTION CREATOR fetchArticles
export const fetchStations = (value1, value2) => ({
  type: FETCH_STATIONS,
  value1,
  value2,
});
// ACTION TYPE SAVE_ARTICLES
export const SAVE_STATIONS = 'SAVE_STATIONS';

// ACTION CREATOR saveArticles
export const saveStations = (stations) => ({
  type: SAVE_STATIONS,
  stations,
});

// ACTION TYPE FETCH_FULL_ONE_STATION_DATA
export const FETCH_FULL_ONE_STATION_DATA = 'FETCH_FULL_ONE_STATION_DATA';

// ACTION CREATOR fetchFullOneStationData
export const fetchFullOneStationData = (query, server, glassapi) => ({
  type: FETCH_FULL_ONE_STATION_DATA,
  query,
  server,
  glassapi,
});

// ACTION TYPE SAVE_FULL_ONE_STATION_DATA
export const SAVE_FULL_ONE_STATION_DATA = 'SAVE_FULL_ONE_STATION_DATA';

// ACTION CREATOR saveFullData
export const saveFullOneStationData = (fullData) => ({
  type: SAVE_FULL_ONE_STATION_DATA,
  fullData,
});

// ACTION TYPE DOWNLOAD_GEODE_SYML_FILE
export const DOWNLOAD_GEODE_SYML_FILE = 'DOWNLOAD_GEODE_SYML_FILE';

// ACTION CREATOR downloadGeodeSymlFile
export const downloadGeodeSymlFile = (marker, server, glassapi) => ({
  type: DOWNLOAD_GEODE_SYML_FILE,
  marker,
  server,
  glassapi,
});

// ACTION TYPE DOWNLOAD_SITE_LOG_FILE
export const DOWNLOAD_SITE_LOG_FILE = 'DOWNLOAD_SITE_LOG_FILE';

// ACTION CREATOR downloadSiteLogFile
export const downloadSiteLogFile = (marker, server, glassapi) => ({
  type: DOWNLOAD_SITE_LOG_FILE,
  marker,
  server,
  glassapi,
});

// ACTION TYPE FETCH_CALENDAR_DATA
export const FETCH_CALENDAR_DATA = 'FETCH_CALENDAR_DATA';

// ACTION CREATOR fetchCalendarData
export const fetchCalendarData = (query, server, glassapi) => ({
  type: FETCH_CALENDAR_DATA,
  query,
  server,
  glassapi,
});

// ACTION TYPE FETCH_QUALITY_DATA
export const FETCH_QUALITY_DATA = 'FETCH_QUALITY_DATA';

// ACTION CREATOR fetchQualityData
export const fetchQualityData = (marker, dateFrom, dateTo, server, glassapi) => ({
  type: FETCH_QUALITY_DATA,
  marker,
  dateFrom,
  dateTo,
  server,
  glassapi,
});

// ACTION TYPE FETCH_FULL_SELECTED_STATION_DATA
export const FETCH_FULL_SELECTED_STATION_DATA = 'FETCH_FULL_SELECTED_STATION_DATA';

// ACTION CREATOR fetchFullSelectedStationData
export const fetchFullSelectedStationData = (query, server, glassapi) => ({
  type: FETCH_FULL_SELECTED_STATION_DATA,
  query,
  server,
  glassapi,
});

// ACTION TYPE FETCH_FILES_DATA
export const FETCH_FILES_DATA = 'FETCH_FILES_DATA';

// ACTION CREATOR fetchFilesData
export const fetchFilesData = (query, server, glassapi) => ({
  type: FETCH_FILES_DATA,
  query,
  server,
  glassapi,
});

// ACTION TYPE SET_CHARGING_NEW_LIST_STATIONS
export const SET_CHARGING_NEW_LIST_STATIONS = 'SET_CHARGING_NEW_LIST_STATIONS';

// ACTION CREATOR setChargingNewListStations
export const setChargingNewListStations = (value) => ({
  type: SET_CHARGING_NEW_LIST_STATIONS,
  value,
});
